













































































































































import { Component, Vue, Watch } from "vue-property-decorator";
import { MediumCoverage } from "@/models";
import Company from "@/models/Company";
import VSignPost from "@/components/Company/VSignPost.vue";
import VMiniLogo from "@/components/VMiniLogo.vue";
import Sidebar from "@/components/Analysis/SideBar.vue";
import AnalysisService from "@/service/AnalysisService";
import CompanyService from "@/service/CompanyService";
import MediumType, { MediumTypology } from "@/models/MediumType";
import HeatmapTable from "@/components/HeatmapTable.vue";
import { currentScoutingStore } from "@/store/typed";
import { ScoutingAnalysis } from "@/models/Scouting";
import Percent from "@/filters/Percent";
import FormatNumber from "@/filters/FormatNumber";
import NumberFormatter from "@/service/NumberFormatter";
import VResumeeCard, { ResumeeItem } from "@/components/VResumeeCard.vue";
import QuadrantChart, {
  QuadrantChartItem,
  QuadrantChartLabels,
} from "@/components/QuadrantChart.vue";
import ScoutingMedium from "@/models/ScoutingMedium";
import ScoutingMediumService from "@/service/ScoutingMediumService";
import VCheckbox from "@/components/VCheckbox.vue";
import MediumTypeService from "@/service/MediumTypeService";
import VContentLoading from "@/components/VContentLoading.vue";

@Component({
  components: {
    QuadrantChart,
    VResumeeCard,
    VMiniLogo,
    Sidebar,
    HeatmapTable,
    VCheckbox,
    VContentLoading,
  },
  filters: { Percent, FormatNumber },
})
export default class AnalysisMediumDetail extends Vue {
  mediumTypeId = "";
  sourceableId = "";
  sourceableType = "";

  xMinValue = 0;
  xMaxValue = 0;
  yMinValue = 0;
  yMaxValue = 0;

  loading = false;

  mediumTypologyUi: MediumTypology = {
    name: "",
    id: "",
    icon: "",
    reach: "",
    unitOfMeasurement: "",
    position: 0,
    showInSlides: true,
  };
  mediumType: MediumType | undefined = undefined;
  analysis: ScoutingAnalysis | undefined = new ScoutingAnalysis();
  company: Company | null = null;
  unfilteredAudiences: any[] = [];
  resumeeItems: ResumeeItem[] = [];
  quadrantChartItems: QuadrantChartItem[] = [];
  selectedMediumCoverages: any[] = [];

  async mounted() {
    this.loading = true;

    this.mediumTypeId = this.$route.query.mediumTypeId as string;
    this.sourceableId = this.$route.query.sourceableId as string;
    this.sourceableType = this.$route.query.sourceableType as string;
    this.company = await CompanyService.getCompany(this.companyId);
    const mediumTypes = await MediumTypeService.getRawMediumTypes();
    this.mediumType = mediumTypes.find(
      (mediumType) => mediumType.id === this.mediumTypeId
    );
    if (this.mediumType)
      this.mediumTypologyUi = this.buildMediumTypologyFromMediumType(
        this.mediumType
      );
    this.analysis =
      (await currentScoutingStore.scoutingAnalysis) ||
      (await currentScoutingStore.loadScoutingAnalysis(this.analysisId));

    await this.load();

    this.loading = false;
  }

  get analysisName() {
    return this.analysis?.scouting?.analysisName || "";
  }

  @Watch("selectedMediumCoverages")
  onSelectedMediumCoveragesChanged() {
    this.buildResumeeItems();
    this.buildQuadrantChartItems();
  }

  isMediumSelected(id: string | number) {
    return this.selectedMediumCoverages.find((e) => e === id) !== undefined;
  }

  getAudience(id: string | number) {
    return this.audiences?.find((e) => e.id === id);
  }

  logoPath(value: Company) {
    return VSignPost.removeHeadingBackSlash(value.croppedLogo || "");
  }

  buildMediumTypologyFromMediumType(mediumType: MediumType): MediumTypology {
    return {
      name: mediumType.name,
      id: mediumType.id,
      icon: `media-${mediumType.typology}`,
      reach: mediumType.reach,
      unitOfMeasurement: mediumType.unitOfMeasurement,
      position: mediumType.position,
      showInSlides: mediumType.showInSlides,
    };
  }

  async load() {
    this.unfilteredAudiences = [];
    const audiences = (await AnalysisService.getSourceableMediumCoverages(
      this.sourceableType,
      this.sourceableId
    )) as MediumCoverage[];
    if (audiences) {
      this.unfilteredAudiences = audiences.map((audience) => {
        if (this.analysis?.scouting.metadata.populations) {
          audience.coverage =
            audience.audience / this.analysis.scouting.metadata.populations;
        }
        audience.quantity = 1;
        audience.budget = "" + parseInt(audience.budget);
        return audience;
      });
    }
    await this.buildSelectedMediumCoverages();
    this.buildResumeeItems();
    this.buildQuadrantChartItems();
    this.setQuadrantChartAxis();
  }

  async buildSelectedMediumCoverages() {
    const scoutingMedia: ScoutingMedium[] =
      await ScoutingMediumService.getScoutingMedia(this.analysisId);
    this.selectedMediumCoverages = this.audiences.map((mediumCoverage) => {
      const scoutingMedium = scoutingMedia.find(
        (scoutingMedium: ScoutingMedium) =>
          scoutingMedium.sourceableId + "" === this.sourceableId &&
          scoutingMedium.medium.id === mediumCoverage.id
      );
      if (scoutingMedium) return scoutingMedium.medium.id;
    });

    this.unfilteredAudiences = this.unfilteredAudiences.map(
      (mediumCoverage) => {
        const scoutingMedium = scoutingMedia.find(
          (scoutingMedium: ScoutingMedium) =>
            scoutingMedium.sourceableId + "" === this.sourceableId &&
            scoutingMedium.medium.id === mediumCoverage.id
        );

        if (scoutingMedium) {
          mediumCoverage.budget = parseInt(scoutingMedium.budget);
          mediumCoverage.quantity = scoutingMedium.quantity;
        }

        return mediumCoverage;
      }
    );
  }

  onInputChanged() {
    this.buildResumeeItems();
  }

  checkInput(event: any) {
    if (!/\d/.test(event.key)) return event.preventDefault();
  }

  get quadrantChartLabels(): QuadrantChartLabels {
    return {
      rightLabel: "Alta copertura",
      leftLabel: "Bassa copertura",
      topLabel: "Bassa dispersione",
      bottomLabel: "Alta dispersione",
    };
  }

  buildQuadrantChartItems() {
    this.quadrantChartItems = [];
    this.selectedMediumCoverages.map((selectedMediaCoverage) => {
      const mediaCoverage = this.audiences.find(
        (o) => o.id === selectedMediaCoverage
      );
      if (mediaCoverage) {
        const item: QuadrantChartItem = {
          label: mediaCoverage.name,
          xPercentage: mediaCoverage.coverage * 100,
          yPercentage: mediaCoverage.dispersion * 100,
        };
        this.quadrantChartItems.push(item);
      }
    });
  }

  setQuadrantChartAxis() {
    const xArray = this.audiences.map((item) => item.coverage * 100);
    const yArray = this.audiences.map((item) => item.dispersion * 100);

    this.xMinValue = Math.min(...xArray);
    this.xMaxValue = Math.max(...xArray);
    this.yMinValue = Math.min(...yArray);
    this.yMaxValue = Math.max(...yArray);
  }

  buildResumeeItems() {
    let totalBudget = 0;
    this.audiences.forEach((mediaCoverage) => {
      const scoutingMedium = this.selectedMediumCoverages.find(
        (id) => id === mediaCoverage.id
      );
      if (scoutingMedium) {
        const parsedBudget = parseFloat(mediaCoverage.budget);
        if (!isNaN(parsedBudget)) {
          totalBudget +=
            parsedBudget *
            (mediaCoverage.quantity !== "" ? mediaCoverage.quantity : 1);
        }
      }
    });

    const totalSelectedMediumCoverages = this.selectedMediumCoverages.filter(
      (o) => o !== undefined
    );

    const resumeeItemCounters = {
      icon: this.mediumTypologyUi.icon,
      text: totalSelectedMediumCoverages.length.toString(),
      description: "Emittenti",
    };

    const resumeeItemBudget = {
      icon: "budget",
      text: FormatNumber(totalBudget) + " €",
      description: "Budget",
    };

    this.resumeeItems = [];
    this.resumeeItems.push(resumeeItemCounters);
    this.resumeeItems.push(resumeeItemBudget);
  }

  get columns() {
    return [
      { name: "id", label: "", notSortable: true },
      { name: "name", label: "Canale" },
      { name: "audience", label: "Audience" },
      { name: "coverage", label: "Copertura" },
      { name: "dispersion", label: "Dispersione" },
      { name: "quantity", label: "Quantità" },
      { name: "budget", label: "Budget", tooltip: "" },
    ];
  }

  get audiences() {
    let audiences = this.unfilteredAudiences.filter(
      (audience) =>
        audience.reach === this.mediumTypologyUi.reach &&
        audience.mediumTypeId === this.mediumTypologyUi.id
    );
    audiences.forEach(
      (audience) => (audience.tooltip = audience.budgetDescription)
    );
    return audiences;
  }

  get companyId() {
    return this.$route.params.id;
  }

  get analysisId() {
    return this.$route.params.analysisId;
  }

  goBack() {
    this.$router.push({
      name: "company_analysis",
      params: {
        id: this.companyId,
        analysisId: this.analysisId,
      },
    });
  }

  normalizeBudget() {
    this.audiences.forEach((e) => {
      if (e.budget === "") {
        e.budget = 0;
      }

      if (e.quantity === "") {
        e.quantity = 1;
      }
    });
  }

  async saveScoutingMedium() {
    this.normalizeBudget();

    let scoutingMedia: ScoutingMedium[] = [];
    this.selectedMediumCoverages.map((selectedMediumCoverage) => {
      const mediaCoverage = this.audiences.find(
        (o) => o.id === selectedMediumCoverage
      );
      if (mediaCoverage) {
        const scoutingMedium = new ScoutingMedium();
        scoutingMedium.scoutingId = this.analysis?.scouting.id;
        scoutingMedium.mediumId = selectedMediumCoverage;
        scoutingMedium.sourceableId = this.sourceableId;
        scoutingMedium.sourceableType = this.sourceableType;
        scoutingMedium.audience = mediaCoverage.audience;
        scoutingMedium.dispersion = mediaCoverage.dispersion;
        scoutingMedium.coverage = mediaCoverage.coverage;
        scoutingMedium.budget = mediaCoverage.budget;
        scoutingMedium.quantity = mediaCoverage.quantity;
        scoutingMedia.push(scoutingMedium);
      }
    });
    scoutingMedia = await ScoutingMediumService.saveScoutingMedia(
      this.analysis?.scouting.id || "",
      this.mediumTypeId,
      this.sourceableId,
      this.sourceableType,
      scoutingMedia
    );
    this.goBack();
  }

  formatCurrency(value: string) {
    return NumberFormatter.format(parseInt(value)) + " €";
  }
}
